import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@mui/material';
import { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { IVendor, IMultipleVendors, createMultipleVendors, IVendorLists } from 'wisestep-api';
import {
  ControlledTextInput,
  WsAutocompleteInput,
  WsButton,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';
import * as yup from 'yup';

interface AddNewVendorsProps {
  vendorList: IVendorLists | undefined;
}
const schema = yup.object().shape({
  name: yup.string().required('Name  is required'),
  email: yup.string().required('Email  is required').email('Email is required '),
});
const AddNewVendor = ({ vendorList }: AddNewVendorsProps) => {
  const navigate = useNavigate();
  const [disable, setDisable] = useState(true);
  const [vendor, setVendor] = useState<IVendor[]>();

  const formOptions = {
    resolver: yupResolver(schema),
  };
  const methods = useForm(formOptions);

  const { handleSubmit, getValues } = methods;

  const onFormSubmit = async () => {
    const vendorData: IVendor = {
      name: getValues('name'),
      email: getValues('email'),
      organization: getValues('organization'),
      tags: getValues('tags'),
      vendorsInLists: [vendorList?.id ?? ''],
    };
    const query: IMultipleVendors = {
      vendors: [vendorData],
    };
    const response = await createMultipleVendors(query);
    setVendor(response.data);
    setDisable(false);
  };
  return (
    <FormProvider {...methods}>
      <Grid container spacing={2} component={'form'} onSubmit={handleSubmit(onFormSubmit)} py={2}>
        <Grid item xs={4}>
          <ControlledTextInput
            name="name"
            label="Name"
            type="text"
            fullWidth
            placeholder="Vendor Name"
            required
            size="small"
          ></ControlledTextInput>
        </Grid>
        <Grid item xs={4}>
          <ControlledTextInput
            name="email"
            label="Email"
            type="email"
            fullWidth
            placeholder="Eg, johndoe@email.com"
            required
            autoComplete="email"
            size="small"
          ></ControlledTextInput>
          <WsTypography
            variant={WsTypoVariants.BODY2}
            color={
              vendor?.[0].emailBounceStatus == 'Valid' ? WsTypoColors.GREEN : WsTypoColors.ERROR
            }
          >
            {vendor?.[0].emailBounceStatus}
          </WsTypography>
        </Grid>
        <Grid item xs={4}>
          <ControlledTextInput
            name="organization"
            label="Company"
            type="text"
            fullWidth
            id="outlined-basic"
            placeholder="Vendor Company Inc"
            variant="outlined"
            size="small"
          ></ControlledTextInput>
        </Grid>
        <Grid item xs={12}>
          <WsAutocompleteInput
            name="tags"
            options={[]}
            placeholder="Add a tag"
            freeSolo={true}
            multiple={true}
          />
        </Grid>

        <Grid container item xs={12} columnGap={2} py={2} justifyContent="flex-end">
          <WsButton type="submit" variant="outlined">
            Validate & Add
          </WsButton>
          <WsButton
            type="submit"
            variant="outlined"
            onClick={() => navigate(`/vendors/`)}
            disabled={disable}
          >
            Continue
          </WsButton>
        </Grid>
      </Grid>
      <Grid xs={12} alignItems="center">
        <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK}>
          OR
        </WsTypography>
      </Grid>
      <Grid item xs={12} py={2}>
        <WsAutocompleteInput
          name="emails"
          options={[]}
          placeholder="Enter vendors emails"
          freeSolo={true}
          multiple={true}
        />
      </Grid>
    </FormProvider>
  );
};
export default AddNewVendor;
